import React from 'react'
import { Link } from 'react-router-dom'

import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import config from '../../../config.json'
import Translation from '../../Translation/cont/Translation'
import OverlaySaveProgram from '../../overlay/container/OverlaySaveProgram'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'

const PageNewsletterPage = ({campaignsData, campaignsOrder, goBackPath=false, programStatus, programError}) => (
    <WrapperPageSimple 
        pageTitleTransId={config.routes.newsletter.transId} 
        closePagePath={config.routes.marketing.path}
        overlay={goBackPath ? (
            <OverlaySaveProgram goBackPath={goBackPath} />
        ) : (
            <RequestOverlayContainer
                programStatus={programStatus} 
                programError={programError}
            />
        )}
    >
        <div className="newsletter-page site-content">
            {campaignsOrder.length > 0 ? (
                <div className="link-container">   
                    {campaignsOrder.map((campaignId, index) => (
                        <Link key={index} className={"link-container-item title-large-light"} to={`${config.routes.newsletter.path}/campaign/${campaignId}`}>
                            {campaignsData[campaignId].name}
                        </Link>
                    ))}
                </div>
            ) : (
                <div><Translation id="print_newsletter_no_campaigns_found">Keine Newsletter Kampagnen gefunden</Translation></div>
            )}
        </div>
    </WrapperPageSimple>
)

export default PageNewsletterPage  